import "./index.css";
import { useTranslation } from "react-i18next";

const EducationIntroDesc = ({ title, desc }) => {
  const { t } = useTranslation();
  return (
    <div className="education-intro-desc">
      <h5>{title ? title : t("education_intro_title")}</h5>
      <p style={{ marginBottom: "10px" }}>
        {desc ? desc : t("education_intro_desc")}
      </p>
    </div>
  );
};

export default EducationIntroDesc;
